export default "__VITE_ASSET__D9W8OPC5__"